import React, { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';

import { Box, Tab, Tabs } from '@mui/material';

import ClassicRewardsReservationsPage from '../ClassicRewardsReservationsPage';
import LoyaltyPayForPointsPage from '../PayForPoints';
import SocieteEsimGeneratorPage from '../SocieteEsimGeneratorPage';
import { loyaltySubTabsContainerSx } from '../loyaltyTabStyles';

type StatsSubTab = 'esim' | 'pay-for-points' | 'classic-rewards';

const SUB_TABS: ReadonlyArray<StatsSubTab> = ['esim', 'pay-for-points', 'classic-rewards'];
const DEFAULT_SUB_TAB: StatsSubTab = 'esim';

function isStatsSubTab(value: string | null): value is StatsSubTab {
  return value !== null && (SUB_TABS as ReadonlyArray<string>).includes(value);
}

/**
 * Offers page: combines the eSIM generator, Pay-for-Points report, and
 * Classic Rewards reservations under a single top-level loyalty tab.
 *
 * Honours `?tab=<sub-tab>` so deep links (e.g. /loyalty/societe/stats?tab=classic-rewards)
 * land on the correct sub-tab.
 */
export default function StatsPage() {
  const location = useLocation();
  const initialTab = (() => {
    const param = new URLSearchParams(location.search).get('tab');
    return isStatsSubTab(param) ? param : DEFAULT_SUB_TAB;
  })();
  const [tab, setTab] = useState<StatsSubTab>(initialTab);

  // Update if the URL query string changes (e.g. via a sibling link).
  useEffect(() => {
    const param = new URLSearchParams(location.search).get('tab');
    if (isStatsSubTab(param)) {
      setTab(param);
    }
  }, [location.search]);

  return (
    <Box>
      <Box sx={loyaltySubTabsContainerSx}>
        <Tabs value={tab} onChange={(_, next) => setTab(next as StatsSubTab)}>
          <Tab value="esim" label="eSIM" />
          <Tab value="pay-for-points" label="Pay for Points" />
          <Tab value="classic-rewards" label="Classic Rewards" />
        </Tabs>
      </Box>

      {tab === 'esim' && <SocieteEsimGeneratorPage />}
      {tab === 'pay-for-points' && <LoyaltyPayForPointsPage />}
      {tab === 'classic-rewards' && <ClassicRewardsReservationsPage />}
    </Box>
  );
}
